import { UiHelpersService, UiModule } from '@shared/ui';
import { PhoenixTrpcClient } from 'apps/phoenix/src/app/utils';
import { Subject, finalize, from, takeUntil } from 'rxjs';

import { Component, OnDestroy, effect, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { TRPCClientError } from '@trpc/client';

@Component({
  selector: 'phoenix-timeline-screenshot-message',
  imports: [UiModule],
  template: `
    <phoenix-expandable-panel
      ariaLabel="timeline-screenshot-message"
      panelTitle="Original Message:"
      [collapseOnScroll]="true"
      [initOpened]="false"
      panelTitleClass="font-semibold"
    >
      @if (itemLoading) {
        <div class="w-full flex items-center justify-center">
          <mat-spinner
            class="mr-3"
            [diameter]="30"
            aria-label="timeline-screenshot-message-spinner"
          ></mat-spinner>
        </div>
      } @else {
        <div
          [textContent]="originalMessage"
          class="mt-2 p-2 mb-2 theme-bg-2 rounded-sm shadow-md leading-relaxed whitespace-pre-line"
        ></div>
      }
      <a
        [href]="routeToOriginalMessage"
        target="_blank"
        class="flex items-center"
        matTooltip="Open original message"
        extraOptions
        (click)="$event.stopPropagation()"
        ><mat-icon>open_in_new</mat-icon>
      </a>
    </phoenix-expandable-panel>
  `,
})
export class TimelineScreenshotMessageComponent implements OnDestroy {
  trpcService = inject(PhoenixTrpcClient);
  uiHelper = inject(UiHelpersService);
  router = inject(Router);
  messageId = input<string>('');
  destroy$ = new Subject();
  itemLoading = false;

  originalMessage = '';

  constructor() {
    effect(() => {
      if (this.messageId()) {
        this.getTimelineScreenshotMessage();
      }
    });
  }

  getTimelineScreenshotMessage(): void {
    this.itemLoading = true;
    from(
      this.trpcService.directCollect.get.query({
        id: this.messageId(),
      })
    )
      .pipe(
        finalize(() => {
          this.itemLoading = false;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data: any) => {
          this.originalMessage = data?.node?.message?.text ?? '';
        },
        error: error => {
          const message =
            error instanceof TRPCClientError && error.data?.code === 'NOT_FOUND'
              ? 'Direct Collect not found'
              : 'Error loading Direct Collect!';
          this.uiHelper.handleErrorMessage(error, message);
        },
      });
  }

  get routeToOriginalMessage(): string {
    return `${this.router.createUrlTree(['direct-collection'], {
      queryParams: {
        query: this.messageId(),
      },
    })}`;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
